import { ServiceCostPrices } from '~/types/tours/costPrice';

import { fixedGroupPricingAsScale } from './departureInventory';

export function serviceCostPriceRows(data?: ServiceCostPrices) {
  const fixedPrices = data && 'fixed' in data ? data.fixed : data && 'fixedPerGroup' in data ? data.fixedPerGroup : [];
  const fixedByDeparturePrices =
    data && 'fixedByDeparture' in data
      ? data.fixedByDeparture
      : data && 'fixedPerGroupByDeparture' in data
        ? data.fixedPerGroupByDeparture
        : [];

  return {
    fixedPrices,
    fixedByDeparturePrices,
    pricing:
      data && 'slidingScale' in data
        ? data.slidingScale
        : data && 'fixedPerGroup' in data
          ? fixedGroupPricingAsScale(data.fixedPerGroup)
          : [],
    byDeparturePricing:
      data && 'slidingScaleByDeparture' in data
        ? data.slidingScaleByDeparture
        : data && 'fixedPerGroupByDeparture' in data
          ? fixedGroupPricingAsScale(data.fixedPerGroupByDeparture)
          : [],
  };
}
